import { memo } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import {
  MsgError,
  MsgLoading,
  MsgSuccess,
} from "../../../components/Loaders/MessageLoaders";
import PkgDestinationCategoriesService from "../../../services/PkgDestinationCategories.service";

export type PkgDesCatInputs = {
  id: string;
  pkg_destination_category: string;
  package_type: string;
  pkg_category_img: string;
};

const TabAddPkgCategories = () => {
  // const [isTranslationActive, setIsTranslationActive] = useState(false)

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
  } = useForm<PkgDesCatInputs>();
  const onSubmit: SubmitHandler<PkgDesCatInputs> = async (data) => {
    try {
      MsgLoading();
      data["pkg_category_img"] = data.pkg_category_img[0];
      const response = await PkgDestinationCategoriesService.StorePkgDestCat(
        data
      );
      MsgSuccess(response.data.msg);
      reset();
    } catch (error: any) {
      if (error.response) {
        MsgError(error.response.data.message);
      }
    }
  };
  return (
    <div>
      {/* {isTranslationActive ? <p className='text-gray-600 mt-8'>Click to add category with <span className='text-primary-base underline cursor-pointer' onClick={() => setIsTranslationActive(false)}> base language </span></p> :
                <p className='text-gray-600 mt-8'>To add translation click <span className='text-primary-base underline cursor-pointer' onClick={() => setIsTranslationActive(true)}> translated package category</span></p>} */}

      <div className="my-4">
        <form action="w-fit my-10 lg:mt-96" onSubmit={handleSubmit(onSubmit)}>
          <div className="flex flex-col space-y-3 my-4">
            <label htmlFor="pkgType">Select Package Type</label>
            <select
              className="form-select inputs md:w-96"
              id="pkgType"
              {...register("package_type", { required: true })}
            >
              <option value="null">----</option>
              <option value="local">Local</option>
              <option value="global">Global</option>
            </select>
            {errors.package_type && (
              <span className="text-red-500">This field is required</span>
            )}
          </div>

          <div className="flex flex-col space-y-3 my-4">
            <label htmlFor="category">Package Category</label>
            <input
              type="text"
              className="form-input inputs md:w-96"
              required
              placeholder="Enter a package category...."
              {...register("pkg_destination_category", { required: true })}
            />
            {errors.pkg_destination_category && (
              <span className="text-red-500">This field is required</span>
            )}
          </div>

          <div className="flex flex-col space-y-2">
            <label htmlFor="img">Imgage</label>
            <input
              type="file"
              id="img"
              className="form-input inputs md:w-96"
              {...register("pkg_category_img", { required: false })}
            />
            {errors.pkg_category_img && (
              <span className="text-red-500">This field is required</span>
            )}
          </div>

          <div className="flex flex-col space-y-3 my-4">
            <input type="submit" className="btn btn-primary" value="Submit" />
          </div>
        </form>
      </div>
    </div>
  );
};

export default memo(TabAddPkgCategories);
